import { api } from "../utils/AuthManager";
const GetAllMeters = async () => {
  return api
    .get(`/api/meter/`)

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetAllMeters;
